import {combineReducers} from "redux"
import types from "actions/types"

export const data = (state = null, action) => {
  switch (action.type) {
    case types.CUSTOMER_APPROVALS_LOAD_SUCCESS:
      return action.data

    case types.CUSTOMER_APPROVAL_UPDATE_STATUS_ATTEMPT:
      const {id, status} = action

      return {
        ...state,
        approvals: state.approvals.map(approval =>
          approval.id === id
            ? { ...approval, status }
            : approval
        ),
      }

    case types.CUSTOMER_APPROVAL_UPDATE_STATUS_SUCCESS: {
      const updatedApproval = action.data.result

      return {
        ...state,
        approvals: state.approvals.map(approval =>
          approval.id === updatedApproval.id
            ? { ...approval, ...updatedApproval }
            : approval
        ),
      }
    }

    default:
      return state
  }
}

export const error = (state = null, action) => {
  switch (action.type) {
    case types.CUSTOMER_APPROVALS_LOAD_FAILURE:
      return action.message
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.CUSTOMER_APPROVALS_LOAD_ATTEMPT:
      return true
    case types.CUSTOMER_APPROVALS_LOAD_FAILURE:
    case types.CUSTOMER_APPROVALS_LOAD_SUCCESS:
      return false
    default:
      return state
  }
}

export default combineReducers({
  data,
  error,
  isLoading,
})
